export function arrayBufferToBase64(buffer: ArrayBuffer | Uint8Array): string {
  return btoa(String.fromCharCode(...new Uint8Array(buffer)));
}

export function stringToBase64(str: string): string {
  const encoder = new TextEncoder();
  const buffer = encoder.encode(str);
  return arrayBufferToBase64(buffer);
}

export function base64ToString(base64: string): string {
  const decoder = new TextDecoder();
  const buffer = base64ToUint8Array(base64);
  return decoder.decode(buffer);
}

export function base64ToUint8Array(base64: string): Uint8Array {
  return Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
}
